import getTranslation from '../strings/i18n';
import { useAccountSummaryV2Query } from 'syf-api';
import { defaultCardArt } from '../const/defaults';
import { useActivityContext } from '../context/activity-store';
var useCardHeaderValues = function (accountId, overrideConfig) {
    var _a;
    var t = getTranslation().t;
    var config = useActivityContext().config;
    var data = useAccountSummaryV2Query({
        config: overrideConfig || config,
        keyProps: { accountId: accountId, accountIdType: 'guid' }
    }).data;
    if (!data) {
        return null;
    }
    var product = data.product, accountInfo = data.accountInfo, card = data.card;
    return {
        title: product.displayName || t('common.defaultAccountLabel'),
        subtitle: "".concat(t('common.endingInSubHeading'), " ").concat(accountInfo.accountLast4),
        img: (_a = card.cardArtURL) !== null && _a !== void 0 ? _a : defaultCardArt,
        fallbackImage: '',
        alt: ''
    };
};
export default useCardHeaderValues;
//# sourceMappingURL=use-card-header-values.js.map